import { render, staticRenderFns } from "./BXCQPay.vue?vue&type=template&id=4ce86b8a&scoped=true"
import script from "./BXCQPay.vue?vue&type=script&lang=js"
export * from "./BXCQPay.vue?vue&type=script&lang=js"
import style0 from "./BXCQPay.vue?vue&type=style&index=0&id=4ce86b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce86b8a",
  null
  
)

export default component.exports